import { call, put, takeLatest } from 'redux-saga/effects';

import { getUnexplainedPaymentsList } from '../../services/API/unexplainedPayments';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getUnexplainedPaymentsList, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* unexplainedPaymentsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
